export default __webpack_public_path__ + "USt_selections.html";